/**
 * OutsourcingContractAdminPage (P338).
 *
 * Mount point for /foundation/admin/outsourcing-contracts. Thin
 * wrapper handing `outsourcingContractAdapter` to the shared
 * `AdminListView`. Mirrors RiskAppetiteAdminPage exactly.
 */
import { AdminListView } from "./AdminListView";
import { ContractReviewPanel } from "./ContractReviewPanel";
import { outsourcingContractAdapter } from "./outsourcingContractAdapter";

export function OutsourcingContractAdminPage() {
  return (
    <>
      <ContractReviewPanel />
      <AdminListView adapter={outsourcingContractAdapter} />
    </>
  );
}
